import list from 'src/modules/event/list/eventListReducers';
import form from 'src/modules/event/form/eventFormReducers';
import view from 'src/modules/event/view/eventViewReducers';
import destroy from 'src/modules/event/destroy/eventDestroyReducers';
import importerReducer from 'src/modules/event/importer/eventImporterReducers';
import publish from 'src/modules/event/publish/eventPublishReducers';
import unpublish from 'src/modules/event/unpublish/eventUnpublishReducers';
import publicschedule from 'src/modules/event/publicschedule/eventPublicScheduleReducers';
import notpublicschedule from 'src/modules/event/notpublicschedule/eventNotPublicScheduleReducers';
import clone from 'src/modules/event/clone/eventCloneReducers';
import promote from 'src/modules/event/promote/eventPromoteReducers';
import demote from 'src/modules/event/demote/eventDemoteReducers';
import aiChat from 'src/modules/event/aiChat/eventAiChatReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
  publish,
  unpublish,
  publicschedule,
  notpublicschedule,
  clone,
  promote,
  demote,
  aiChat,
});
